import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import ScreensSourceList from 'screens/Sources/List/ScreensSourceList';
import ScreensSourceForm from 'screens/Sources/Form/ScreensSourceForm';

function ScreensSource() {
  return (
    <Routes>
      <Route
        path="/list"
        element={
          <RoutePrivate
            element={ScreensSourceList}
            requiredPermission="sources.list"
          />
        }
      />
      <Route
        path="/create"
        element={
          <RoutePrivate
            element={ScreensSourceForm}
            requiredPermission="sources.create"
          />
        }
      />
      <Route
        path="/:id/edit"
        element={
          <RoutePrivate
            exact
            element={ScreensSourceForm}
            requiredPermission="sources.update"
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/sources/list" />} />
    </Routes>
  );
}

export default ScreensSource;
